export default {
  'versionLog':	'更新日志'
}
